/**
 * @desc Yung-获取入库单信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.inMasterFacadeImpl.getInMasterInfoBySourceNo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/inMaster/getInMasterInfoBySourceNo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
